<script setup>
import AppButton from '#/general/AppButton.vue'
</script>

<template lang="pug">
.solutions--reference
  .solutions--reference-content
    img.solutions--reference-img.gt-sm(src='~assets/img/solutions/reference1.png' alt='Work Reference')
    img.solutions--reference-img.lt-md(src='~assets/img/solutions/reference1_mobile.png' alt='Work Reference Mobile')
    .solutions--reference-box
      .solutions--reference-box-content
        .solutions--reference-title Referenz
        .solutions--reference-address
          | St. Gallen
          br
          | Kolumbanstrasse
        .solutions--reference-type Projektentwicklung
        app-button.solutions--reference-btn(label="Zum Referenzprojekt" padding="13px 50px" to="/referenzen/stgallen_kolumbanstrasse")
</template>

<style lang="sass">
.solutions--reference
  display: flex
  justify-content: center
  @media screen and (min-width: 1024px)
    margin-top: 87px
  @media screen and (max-width: 1024px)
    margin-top: 75px
  .solutions--reference-content
    width: 100%
    position: relative
    @media screen and (min-width: 1024px)
      max-width: 1800px
    .solutions--reference-img
      width: 100%
      @media screen and (min-width: 1024px)
        padding: 0 20px
        border-radius: 10px
    .solutions--reference-box
      position: absolute
      @media screen and (min-width: 1024px)
        right: 90px
        bottom: -28px
      @media screen and (max-width: 1024px)
        bottom: -160px
        left: 0px
        margin: 0 20px
        width: calc(100% - 40px)
      .solutions--reference-box-content
        position: relative
        padding: 30px 30px 30px
        background: #F6F7FA
        backdrop-filter: blur(5px)
        border-radius: 10px
        @media screen and (min-width: 1024px)
          width: 380px
        @media screen and (max-width: 1024px)
          width: 100%
        .solutions--reference-title
          font-weight: 700
          line-height: 130%
          color: #1F47CD
          @media screen and (min-width: 1024px)
            font-size: 20px
            margin-bottom: 18px
          @media screen and (max-width: 1024px)
            font-size: 16px
            margin-bottom: 10px
        .solutions--reference-address
          font-weight: 400
          line-height: 125%
          background: linear-gradient(152.99deg, #2F3849 24.83%, #21252E 103.84%)
          -webkit-background-clip: text
          -webkit-text-fill-color: transparent
          background-clip: text
          @media screen and (min-width: 1024px)
            font-size: 30px
            margin-bottom: 18px
          @media screen and (max-width: 1024px)
            font-size: 24px
            margin-bottom: 10px
        .solutions--reference-type
          font-weight: 400
          line-height: 150%
          color: #22223C
          @media screen and (min-width: 1024px)
            font-size: 20px
            margin-bottom: 32px
          @media screen and (max-width: 1024px)
            font-size: 16px
            margin-bottom: 25px
        .solutions--reference-btn
          height: 56px
          position: absolute
          bottom: -28px
          @media screen and (min-width: 1024px)
            width: 320px
            left: 30px
          @media screen and (max-width: 1024px)
            left: 15px
            width: calc(100% - 30px)
</style>
